<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex xs12 sm6>
        <v-btn
          depressed
          :outline="filter != 'all'"
          :color="filter == 'all' ? 'primary' : 'grey'"
          class="ma-0 mr-1 mb-1"
          @click="filter = 'all'"
          >{{ $t('All') }}</v-btn
        >
        <v-btn
          depressed
          :outline="filter != 'facebook'"
          :color="filter == 'facebook' ? 'primary' : 'grey'"
          class="ma-0 mr-1 mb-1"
          @click="filter = 'facebook'"
        >
          <em class="fab fa-facebook-square mr-1" />
          {{ $t('Facebook') }}
        </v-btn>
        <v-btn
          depressed
          :outline="filter != 'line'"
          :color="filter == 'line' ? 'primary' : 'grey'"
          class="ma-0 mr-1 mb-1"
          @click="filter = 'line'"
        >
          <em class="fab fa-line mr-1" />
          {{ $t('Line') }}
        </v-btn>
      </v-flex>
      <v-flex xs12 sm6 class="text-sm-right">
        <template v-if="loading">
          <v-btn :loading="true" color="grey" outline class="ma-0 mb-1"></v-btn>
        </template>
        <template v-else>
          <v-btn
            v-if="$store.getters.getPackage != 'premium'"
            v-tooltip.top="'Unlock to PREMIUM plan'"
            outline
            color="grey"
            class="ma-0 mb-1"
          >
            <em class="fas fa-file-export mr-1" />
            {{ $t('export') }}
            <v-premium-lock></v-premium-lock>
          </v-btn>
          <v-btn
            v-else-if="$store.getters.getPackage == 'premium'"
            color="grey"
            outline
            class="ma-0 mb-1"
            @click="exportDashboard"
          >
            <em class="fas fa-file-export mr-1" />
            {{ $t('export') }}
          </v-btn>
        </template>
      </v-flex>
    </v-layout>
    <date-filter v-model="selectedDate" @changeDate="getRows()"></date-filter>

    <h3 class="title">{{ $t('Tag Report') }}</h3>
    <TagReportGraph
      v-if="data.length"
      :selected-date="sortedDate"
      :loading="loading"
      :data="data"
    />
  </v-container>
</template>

<script>
import DateFilter from './../DateFilter'
import TagReportGraph from './TagReportGraph'

import { mapGetters } from 'vuex'
import api from '@/api'
import moment from 'moment'

export default {
  components: {
    DateFilter,
    TagReportGraph
  },
  data() {
    return {
      filter: 'all',
      loading: false,
      selectedDate: {
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment().endOf('month').format('YYYY-MM-DD')
      },
      data: []
    }
  },
  watch: {
    filter() {
      this.getRows()
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    sortedDate() {
      return this.data.sort((a, b) => b.count - a.count)
    }
  },
  mounted() {
    this.getRows()
  },
  methods: {
    getRows() {
      let vm = this
      vm.loading = true
      api.gettagreportgenerali(
        {
          start: moment(this.selectedDate.start).format('YYYY-MM-DD'),
          end: moment(this.selectedDate.end).format('YYYY-MM-DD'),
          filter: vm.filter,
          pageid: vm.selectedBot.pageid
        },
        function (error, response) {
          vm.loading = false
          if (error) {
            console.error(error)
            return
          }
          if (response.responsecode == 200) {
            vm.data = response.data
          }
        }
      )
    },
    exportDashboard: function () {
      let vm = this
      let csvContent = ''
      if (vm.loading) {
        return false
      }

      csvContent +=
        'From,"' +
        moment(vm.selectedDate.start).format('DD/MM/YYYY') +
        '",To,"' +
        moment(vm.selectedDate.end).format('DD/MM/YYYY') +
        '"\r\n'

      csvContent += 'Tag Report by Date\r\n'
      csvContent += 'Tag, Count' + '\r\n'

      $.each(vm.data, function (index, item) {
        csvContent += item.usertags + ',' + item.count + '\r\n'
      })
      // csvContent += '\r\n'
      // csvContent += 'Messages by Time\r\n'
      // csvContent += 'Time,Messages\r\n'

      // $.each(vm.activeuserbytimeSeries[0].data, function(index, seriesData) {
      //   csvContent += index + ':00' + ',"' + numeral(seriesData).format('0,0') + '"\r\n'
      // })
      vm.exportCsv(csvContent, 'crm')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/tag/TagReport.vue